import React from 'react'

import {
  METADATA_ALIAS_BATCH_EDITING,
  METADATA_ALIAS_COMMENTS,
} from '@disco/constants/FeatureTypes'
import { sendMixpanelEvent } from '@disco/state-management/actions/AnalyticsActions'
import { updateUserSettings } from '@disco/state-management/actions/UserActions'
import {
  getTrialLeftSelector,
  useFeatureData,
  useFeatureEnabled,
} from '@disco/state-management/selectors/business'
import {
  getConstanceSetting,
  getUserMetadataAliases,
} from '@disco/state-management/selectors/user'

import { useDispatch, useSelector } from 'hooks/use-redux'

import MetadataSettings from './MetadataSettings'

const MetadataSettingsContainer = (): React.ReactNode => {
  const { isTrial, isFeatureEnabled } = useFeatureData(
    METADATA_ALIAS_BATCH_EDITING,
  )
  const aliasCommentsEnabled = useFeatureEnabled(METADATA_ALIAS_COMMENTS)
  const trialLeft = useSelector(state =>
    getTrialLeftSelector(state, {
      trialMessageMode: 'long',
    }),
  )
  const aliases = useSelector(getUserMetadataAliases)
  const updating = useSelector(state => state.user.updating)
  const recordingTabEnabled = useSelector(state =>
    Boolean(getConstanceSetting(state, 'RIGHTS_DATA_SHOW_RECORDING_TAB')),
  )
  const dispatch = useDispatch()
  return (
    <MetadataSettings
      aliases={aliases}
      isFeatureEnabled={isFeatureEnabled}
      aliasCommentsEnabled={aliasCommentsEnabled}
      isTrial={isTrial}
      recordingTabEnabled={recordingTabEnabled}
      sendMixpanelEvent={(...props) => dispatch(sendMixpanelEvent(...props))}
      trialLeft={trialLeft}
      updateUserSettings={(...props: Parameters<typeof updateUserSettings>) =>
        dispatch(updateUserSettings(...props))
      }
      updating={updating}
    />
  )
}

export default MetadataSettingsContainer
